import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModifyCollectionsPanelComponent } from './modify-collections-panel.component';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		FocusOnFirstInvalidFieldModule
	],
	declarations: [
		ModifyCollectionsPanelComponent
	],
	exports: [
		ModifyCollectionsPanelComponent
	]
})
export class ModifyCollectionsPanelModule {}
